/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SecteurHomogeneSearch
 */
export interface SecteurHomogeneSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof SecteurHomogeneSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SecteurHomogeneSearch
     */
    idstade?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof SecteurHomogeneSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecteurHomogeneSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SecteurHomogeneSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SecteurHomogeneSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SecteurHomogeneSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SecteurHomogeneSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SecteurHomogeneSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SecteurHomogeneSearch interface.
 */
export function instanceOfSecteurHomogeneSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecteurHomogeneSearchFromJSON(json: any): SecteurHomogeneSearch {
    return SecteurHomogeneSearchFromJSONTyped(json, false);
}

export function SecteurHomogeneSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecteurHomogeneSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'idstade': !exists(json, 'idstade') ? undefined : Int32ListSearchFromJSON(json['idstade']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SecteurHomogeneSearchToJSON(value?: SecteurHomogeneSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'idstade': Int32ListSearchToJSON(value.idstade),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

